import { render, staticRenderFns } from "./SocialFeedItem.vue?vue&type=template&id=27505b68&scoped=true&"
import script from "./SocialFeedItem.vue?vue&type=script&lang=js&"
export * from "./SocialFeedItem.vue?vue&type=script&lang=js&"
import style0 from "./SocialFeedItem.vue?vue&type=style&index=0&id=27505b68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27505b68",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAvatar,VFlex,VSpacer})
